import {
  SecretResponse,
  CreateSecretRequest,
  UpdateSecretRequest,
} from "@/types/breeze/Secret";
import { BaseService } from "../BaseService";

export class SecretService extends BaseService {
  public async getSecrets(): Promise<SecretResponse[]> {
    return this.getRequest("/secrets");
  }

  public async createSecret(
    request: CreateSecretRequest,
  ): Promise<SecretResponse> {
    return this.postRequest("/secrets", request, "Secret created successfully");
  }

  public async updateSecret(
    key: string,
    request: UpdateSecretRequest,
  ): Promise<SecretResponse> {
    return this.putRequest(
      `/secrets/${key}`,
      request,
      "Secret updated successfully",
    );
  }

  public async deleteSecret(key: string): Promise<void> {
    return this.deleteRequest(`/secrets/${key}`, "Secret deleted successfully");
  }
}

export const secretService = new SecretService();
